module.exports = __webpack_public_path__ + "img/sales_purchase_cs.a21186a7.png";